import { ArrayField, Field } from "sparkson";

export interface PartDebugInfoParameter {
  name: string;
  value: string;
  html: boolean;
}

export class PartDebugInfo {
  readonly parameters: Readonly<PartDebugInfoParameter>[];

  constructor(
    @Field("index") public index: number,
    @Field("startTime") public startTime: number,
    @Field("endTime") public endTime: number,
    @Field("markerName") public markerName: string,
    @Field("parentVideoCode") public parentVideoCode: string,
    @ArrayField("parameters", String) parameters: string[],
    @ArrayField("values", String) values: string[],
    @ArrayField("htmlParameters", String) htmlParameters: string[],
    @ArrayField("htmlValues", String) htmlValues: string[],
  ) {
    this.parameters = this.constructParameters(parameters, values, htmlParameters, htmlValues);
  }

  private constructParameters(
    parameters: string[],
    values: string[],
    htmlParameters: string[],
    htmlValues: string[],
  ): PartDebugInfoParameter[] {
    if (parameters.length !== values.length) {
      throw new Error("Parameters and values arrays must have the same length");
    }

    if (htmlParameters.length !== htmlValues.length) {
      throw new Error("HTML parameters and values arrays must have the same length");
    }

    const mappedParameters = parameters.map((parameter, index) => ({
      name: parameter,
      value: values[index],
      html: false,
    }));

    const mappedHtmlParameters = htmlParameters.map((parameter, index) => ({
      name: parameter,
      value: htmlValues[index],
      html: true,
    }));

    return mappedParameters.concat(mappedHtmlParameters);
  }
}
